import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  PluginEnableContext,
  SupportedPluginContentfulDataType,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import loadable from "@loadable/component";
import { productOptions } from "../pluginOwners";

export const ProductOptionQuantitySelectorsPercentSavingComponent: ComponentToBeRegistered<any> = {
  placeholder: Placeholder.QuantityDropdown,
  Component: loadable(() => import("./PercentSaving")),
  name: "ProductOptionQuantitySelectorsPercentSavingComponent",
  dataNeeds: {
    contentful: {
      quantity: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Quantity",
      },
      recommended: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "callout.Recommended",
      },
      bulkOrderQuantity: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Bulk Order > Quantity",
      },
    },
  },
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    const { pageProps } = context;
    const { ssrQuantities } = pageProps;
    if (ssrQuantities.length <= 12) {
      return true;
    }
    return false;
  },
};

export const productOptionQuantitySelectors: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, ProductOptionQuantitySelectorsPercentSavingComponent);
  },
  pluginOwner: productOptions,
};
